module.exports = __webpack_public_path__ + "img/card-bg1.1d8570b3.png";